export const DownloadCsv = (props: any) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      {...props}
      d="M12.0001 10.0003V12.0003H4.00008V10.0003H2.66675V12.0003C2.66675 12.7337 3.26675 13.3337 4.00008 13.3337H12.0001C12.7334 13.3337 13.3334 12.7337 13.3334 12.0003V10.0003H12.0001ZM11.3334 7.33366L10.3934 6.39366L8.66675 8.11366V2.66699H7.33341V8.11366L5.60675 6.39366L4.66675 7.33366L8.00008 10.667L11.3334 7.33366Z"
      fill={props.fill}
    />
  </svg>
);
